import { CheckoutOrder, CheckoutProduct, PaymentForm } from "tm-shared/types";

import {
    FORM_1_COMMENTS,
    FORM_2_COMMENTS,
} from "@/pages/Checkout/constants/comments";

interface PaymentFormEntry {
    orderId: string;
    isCarrier?: boolean;
    isSelfDelivery?: boolean;
    comments?: string[];
    isCredit: boolean;
    shipmentDate?: string;
}

interface FormData {
    isCarrier?: boolean;
    isSelfDelivery?: boolean;
    isPayOnDelivery?: boolean;
    comment?: string;
    commentChecked?: boolean;
}

export const convertCheckoutListToMarketProducts = (
    checkoutList: Record<string, CheckoutOrder>,
    ignoreRemainingsOrders: Record<string, unknown>,
) => {
    const marketProducts: Record<string, CheckoutProduct[]> = {};
    const ignoreRemainings: Record<string, { ignoreRemainings: boolean }> = {};
    const paymentForms: Record<string, string> = {};

    for (const orderId in checkoutList) {
        const order = checkoutList[orderId];

        if (!order) continue;

        const { products, paymentForm } = order;

        marketProducts[orderId] = [];
        const productsMap: Record<string, CheckoutProduct> = {};

        for (const barcode in products) {
            const product = products[barcode];

            if (!product) continue;

            const { name, price, count } = product;

            if (!productsMap[barcode]) {
                productsMap[barcode] = { barcode, name, price, count: 0 };
                marketProducts[orderId].push(productsMap[barcode]);
            }

            productsMap[barcode].count += count;
        }

        paymentForms[orderId] = paymentForm;

        if (orderId in ignoreRemainingsOrders) {
            ignoreRemainings[orderId] = { ignoreRemainings: true };
        }
    }

    return {
        marketProducts,
        ignoreRemainingsOrders: ignoreRemainings,
        paymentForms,
    };
};

export const processPaymentForm = (
    formData: FormData | undefined,
    orderId: string,
    formNumber: PaymentForm,
    customShipmentDate: string,
): PaymentFormEntry[] => {
    if (!formData) return [];

    const {
        isCarrier,
        isSelfDelivery,
        isPayOnDelivery,
        commentChecked,
        comment,
    } = formData;
    const isAnyFlagChecked =
        isCarrier || isSelfDelivery || isPayOnDelivery || commentChecked;

    if (!isAnyFlagChecked) {
        if (customShipmentDate) {
            return [
                {
                    orderId,
                    isCredit: true,
                    shipmentDate: customShipmentDate,
                },
            ];
        } else {
            return [
                {
                    orderId,
                    isCredit: true,
                },
            ];
        }
    }

    const comments: string[] = [];

    if (commentChecked && comment) {
        comments.push(comment);
    }

    if (formNumber === PaymentForm.Card1 && isPayOnDelivery) {
        comments.push(FORM_1_COMMENTS.isPayOnDelivery);
    }

    if (formNumber === PaymentForm.Cash2) {
        if (isSelfDelivery) comments.push(FORM_2_COMMENTS.isSelfDelivery);

        if (isPayOnDelivery) {
            comments.push(
                isSelfDelivery
                    ? FORM_2_COMMENTS.isPayOnDeliveryisSelfDelivery
                    : FORM_2_COMMENTS.isPayOnDelivery,
            );
        }
    }

    return [
        {
            orderId,
            isCarrier: formNumber === PaymentForm.Cash2 ? isCarrier : undefined,
            isSelfDelivery:
                formNumber === PaymentForm.Cash2 ? isSelfDelivery : undefined,
            isCredit: !isPayOnDelivery,
            shipmentDate: customShipmentDate,
            comments,
        },
    ];
};
